/**
 * RTWO Asset & Token Engine — Null Smart Contract Runtime Adapter
 */

import type { AssetId, RTWOAssetLifecycleStage } from '../domain-models';
import type {
  IScrtRuntimeAdapter,
  ScrtRuntimeAdapterStatus,
} from './scrt-runtime-adapter-interface';

export class NullScrtRuntimeAdapter implements IScrtRuntimeAdapter {
  readonly adapterId = 'null-scrt-runtime-adapter';
  readonly adapterName = 'Null Smart Contract Runtime Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): ScrtRuntimeAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async configureSupplyPolicy(
    _assetId: AssetId,
    _supplyType: string,
    _maxSupplyReference: string,
    _mintingPolicy: string,
    _burningPolicy: string
  ) {
    return null;
  }

  async configureTransferRule(_assetId: AssetId, _ruleType: string, _conditionReference: string) {
    return null;
  }

  async validateAsset(_assetId: AssetId) {
    return null;
  }

  async transitionLifecycle(_assetId: AssetId, _targetStage: RTWOAssetLifecycleStage) {
    return null;
  }
}
